import Loader from "atoms/loader"
import Stack from "molecules/stack/stack"
import StackItem from "molecules/stackItem/stackItem"

export const Dot9loader = () => {
    return (
        <Stack isVertical>
            <StackItem isGrow isStretch align="center">
                <Loader />
            </StackItem>
        </Stack>
    )
}
